import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

require('./bringoz-status-tag.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-status-tag',
  templateUrl: './bringoz-status-tag.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozStatusTagComponent {

  @Input() status: string;
  @Input() extraText: string;
  @Input() extraTooltipText: string;
  @Input() isSmall: boolean;
  @Input() isSecondary: boolean;
  @Input() entity: string;

  constructor() {
  }

}
